import { Component, OnInit } from '@angular/core';
import { faLinkedinIn, faTwitter, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'login-juridico',
    templateUrl : './login.component.html',
    styleUrls : ['../../juridico.component.css', './login.component.css']
})

export class LoginJuridicoComponent implements OnInit {
  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;
  siteUrl: string = "";
  ano = new Date().getFullYear();
  menuAberto = false;

  URL = "https://www.reachr.com.br/";

  constructor(private meta: Meta) {
    this.siteUrl = environment.serverUrl;
    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Entrar como Empresa'
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Gerencie todo o seu processo de recrutamento e seleção em uma única plataforma. Reachr, a solução prática e inteligente de recrutamento digital.'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'vagas de emprego, oportunidade de trabalho, agencia de emprego, vagas, emprego, vaga de emprego, trabalhe conosco comunidade de emprego,'
    // });
  }

  ngOnInit(): void {
  }
}